import {
  LuBell,
  LuMessageSquare,
  LuMail,
  LuPhone,
  LuVideo,
  LuRss,
  LuBookOpen,
  LuFileText,
  LuFolderOpen,
  LuClipboardCheck,
  LuClipboardList,
  LuDownload,
  LuUpload,
  LuCreditCard,
  LuWallet,
  LuReceipt,
  LuBriefcase,
  LuBuilding,
  LuLandmark,
  LuUsers,
  LuUser,
  LuUserCheck,
  LuHandshake,
  LuGift,
  LuBadgeCheck,
  LuCircleCheck,
  LuCircleAlert,
  LuInfo,
  LuCircleHelp,
  LuSparkles,
  LuStar,
  LuHeart,
  LuTrendingUp,
  LuRocket,
  LuLightbulb,
  LuCalendar,
  LuCalendarDays,
  LuClock,
  LuGlobe,
  LuLink,
  LuExternalLink,
  LuArrowRight,
  LuMapPin,
  LuSettings,
  LuWrench,
  LuShield,
  LuLock,
  LuTag,
  LuNewspaper,
  LuImage,
  LuLayoutDashboard,
  LuRefreshCw,
  LuLinkedin,
  LuTwitter,
  LuFolderKanban,
  LuBuilding2,
  LuBriefcaseBusiness,
  LuShieldCheck,
  LuBookOpenCheck,
} from 'react-icons/lu';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaGithub,
  FaTelegram,
  FaQuestionCircle,
  FaCog,
  FaUser,
  FaFolder,
  FaCheckCircle,
  FaLock,
  FaReceipt,
  FaMoneyBillWave,
  FaEnvelope,
  FaComments,
} from 'react-icons/fa';

const ICON_MAP = {
  LuBell,
  LuMessageSquare,
  LuMail,
  LuPhone,
  LuVideo,
  LuRss,
  LuBookOpen,
  LuFileText,
  LuFolderOpen,
  LuClipboardCheck,
  LuClipboardList,
  LuDownload,
  LuUpload,
  LuCreditCard,
  LuWallet,
  LuReceipt,
  LuBriefcase,
  LuBuilding,
  LuLandmark,
  LuUsers,
  LuUser,
  LuUserCheck,
  LuHandshake,
  LuGift,
  LuBadgeCheck,
  LuCircleCheck,
  LuCircleAlert,
  LuInfo,
  LuCircleHelp,
  LuSparkles,
  LuStar,
  LuHeart,
  LuTrendingUp,
  LuRocket,
  LuLightbulb,
  LuCalendar,
  LuCalendarDays,
  LuClock,
  LuGlobe,
  LuLink,
  LuExternalLink,
  LuArrowRight,
  LuMapPin,
  LuSettings,
  LuWrench,
  LuShield,
  LuLock,
  LuTag,
  LuNewspaper,
  LuImage,
  LuLayoutDashboard,
  LuRefreshCw,
  LuLinkedin,
  LuTwitter,
  LuFolderKanban,
  LuBuilding2,
  LuBriefcaseBusiness,
  LuShieldCheck,
  LuBookOpenCheck,
  FaComments,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaGithub,
  FaTelegram,
  FaQuestionCircle,
  FaCog,
  FaUser,
  FaFolder,
  FaCheckCircle,
  FaLock,
  FaReceipt,
  FaMoneyBillWave,
  FaEnvelope,
};

const COLOR_MAP = {
  emerald: {
    border: 'hover:border-emerald-300 dark:hover:border-emerald-500',
    iconWrap: 'bg-emerald-50 dark:bg-emerald-900/30',
    icon: 'text-emerald-600 dark:text-emerald-400',
    viewBtn: 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/40',
    downloadBtn: 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-500/30',
    actionBtn: 'bg-emerald-500 hover:bg-emerald-600 shadow-emerald-500/30',
  },
  blue: {
    border: 'hover:border-blue-300 dark:hover:border-blue-500',
    iconWrap: 'bg-blue-50 dark:bg-blue-900/30',
    icon: 'text-blue-600 dark:text-blue-400',
    viewBtn: 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/40',
    downloadBtn: 'bg-blue-600 hover:bg-blue-700 shadow-blue-500/30',
    actionBtn: 'bg-blue-600 hover:bg-blue-700 shadow-blue-500/30',
  },
  purple: {
    border: 'hover:border-purple-300 dark:hover:border-purple-500',
    iconWrap: 'bg-purple-50 dark:bg-purple-900/30',
    icon: 'text-purple-600 dark:text-purple-400',
    viewBtn: 'bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400 hover:bg-purple-100 dark:hover:bg-purple-900/40',
    downloadBtn: 'bg-purple-600 hover:bg-purple-700 shadow-purple-500/30',
    actionBtn: 'bg-purple-600 hover:bg-purple-700 shadow-purple-500/30',
  },
  primary: {
    border: 'hover:border-primary-300 dark:hover:border-primary-500',
    iconWrap: 'bg-primary-50 dark:bg-primary-900/30',
    icon: 'text-primary-600 dark:text-primary-400',
    viewBtn: 'bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400 hover:bg-primary-100 dark:hover:bg-primary-900/40',
    downloadBtn: 'bg-primary-600 hover:bg-primary-700 shadow-primary-500/30',
    actionBtn: 'bg-primary-600 hover:bg-primary-700 shadow-primary-500/30',
  },
  secondary: {
    border: 'hover:border-secondary-300 dark:hover:border-secondary-500',
    iconWrap: 'bg-secondary-50 dark:bg-secondary-900/30',
    icon: 'text-secondary-600 dark:text-secondary-400',
    viewBtn: 'bg-secondary-50 dark:bg-secondary-900/20 text-secondary-600 dark:text-secondary-400 hover:bg-secondary-100 dark:hover:bg-secondary-900/40',
    downloadBtn: 'bg-secondary-600 hover:bg-secondary-700 shadow-secondary-500/30',
    actionBtn: 'bg-secondary-600 hover:bg-secondary-700 shadow-secondary-500/30',
  },
  amber: {
    border: 'hover:border-amber-300 dark:hover:border-amber-500',
    iconWrap: 'bg-amber-50 dark:bg-amber-900/30',
    icon: 'text-amber-600 dark:text-amber-400',
    viewBtn: 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/40',
    downloadBtn: 'bg-amber-500 hover:bg-amber-600 shadow-amber-500/30',
    actionBtn: 'bg-amber-500 hover:bg-amber-600 shadow-amber-500/30',
  },
  rose: {
    border: 'hover:border-rose-300 dark:hover:border-rose-500',
    iconWrap: 'bg-rose-50 dark:bg-rose-900/30',
    icon: 'text-rose-600 dark:text-rose-400',
    viewBtn: 'bg-rose-50 dark:bg-rose-900/20 text-rose-600 dark:text-rose-400 hover:bg-rose-100 dark:hover:bg-rose-900/40',
    downloadBtn: 'bg-rose-600 hover:bg-rose-700 shadow-rose-500/30',
    actionBtn: 'bg-rose-500 hover:bg-rose-600 shadow-rose-500/30',
  },
  cyan: {
    border: 'hover:border-cyan-300 dark:hover:border-cyan-500',
    iconWrap: 'bg-cyan-50 dark:bg-cyan-900/30',
    icon: 'text-cyan-600 dark:text-cyan-400',
    viewBtn: 'bg-cyan-50 dark:bg-cyan-900/20 text-cyan-600 dark:text-cyan-400 hover:bg-cyan-100 dark:hover:bg-cyan-900/40',
    downloadBtn: 'bg-cyan-600 hover:bg-cyan-700 shadow-cyan-500/30',
    actionBtn: 'bg-cyan-500 hover:bg-cyan-600 shadow-cyan-500/30',
  },
  orange: {
    border: 'hover:border-orange-300 dark:hover:border-orange-500',
    iconWrap: 'bg-orange-50 dark:bg-orange-900/30',
    icon: 'text-orange-600 dark:text-orange-400',
    viewBtn: 'bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 hover:bg-orange-100 dark:hover:bg-orange-900/40',
    downloadBtn: 'bg-orange-600 hover:bg-orange-700 shadow-orange-500/30',
    actionBtn: 'bg-orange-500 hover:bg-orange-600 shadow-orange-500/30',
  },
};

export const getPortalIcon = (iconName) => ICON_MAP[iconName] || LuFileText;

export const getPortalColor = (color) => COLOR_MAP[color] || COLOR_MAP.primary;

export const buildResourceFileUrl = (fileUrl, apiBase, fallbackAsset) => {
  if (fileUrl) {
    if (fileUrl.startsWith('http') || fileUrl.startsWith('blob:') || fileUrl.startsWith('data:')) {
      return fileUrl;
    }
    if (fileUrl.startsWith('/')) {
      return `${apiBase}${fileUrl}`;
    }
    return fileUrl;
  }
  return fallbackAsset || '';
};
